export default "* Stenalderpung\n* Læder\n* Cirkel\n";